/**
 * TODO: At magazine launch, delete this module and link "/magazine" directly from the footer and the learn-more
 * page. Note that it hides the links, not the route: /magazine still answers for anyone holding
 * the URL.
 */
export const MEDIUM_BLOG_URL = "https://makelovenotporn.medium.com"

const ADMIN_ROLE = 1

export const blogLink = (user?: { Role?: number } | null) =>
  user?.Role === ADMIN_ROLE ?
    { name: "MLNP Magazine", href: "/magazine", target: undefined }
  : { name: "Read our blog", href: MEDIUM_BLOG_URL, target: "_blank" }
